import { createContext } from 'react';

const MultiColumnContext = createContext<boolean>(false);

export default MultiColumnContext;
